import { HttpClient } from '@angular/common/http';
import { effect, inject, Injectable, signal } from '@angular/core';
import { catchError, finalize, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  MatSnackBar,
  MatSnackBarRef,
  MatSnackBarModule,
} from '@angular/material/snack-bar';

export interface Post {
  date: string;
  id: string;
  link: string;
  title: { rendered: string };
}

@Injectable({
  providedIn: 'root',
})
export class WordPressService {
  private http = inject(HttpClient);
  private snackBar = inject(MatSnackBar);
  readonly url = environment.wordpress.endpoint;

  readDaily = signal<boolean>(false);

  posts = signal<Post[] | undefined>(undefined);

  isLoading = signal<boolean>(false);
  error = signal<string | null>(null);

  constructor() {
    this.fetchPosts();
  }

  fetchPosts() {
    this.isLoading.set(true);
    this.http
      .get(this.url + '/posts?categories=63')
      .pipe(
        catchError((error) => {
          this.error.set(error || 'Error Getting Daily');

          return of(null);
        }),
        finalize(() => {
          this.isLoading.set(false);
        })
      )
      .subscribe({
        next: (res: any[]) => {
          if (res) {
            const sortedPosts = res.sort(
              (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
            );
            this.posts.set(sortedPosts);
            this.hasReadDaily();
          }
        },
        error: (err) => {
          this.snackBar.open('Error fetching Daily' + err, null, {
            duration: 4500,
            panelClass: ['blue-snackbar'],
          });
        },
      });
  }

  hasReadDaily() {
    const userLastReadPost = JSON.parse(
      localStorage.getItem('readDaily') ||
        JSON.stringify({ id: 0, hasRead: false })
    );
    localStorage.setItem('readDaily', JSON.stringify(userLastReadPost));
    // if there posts get the latest post's id and check the local storage id and if it's read
    const latestPost: number = +this.posts()[0].id;
    const userLastReadPostId = userLastReadPost.id;
    this.readDaily.set(latestPost === userLastReadPostId);
  }

  setDaily(read: boolean) {
    this.readDaily.set(read);
    localStorage.setItem(
      'readDaily',
      JSON.stringify({
        id: this.posts()[0].id,
        hasRead: read,
      })
    );
  }
}
